var _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYsfHomePattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 1004,
    viewBox: "0 0 1512 1004",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 756.186,
    cy: 613.186,
    r: 885.624,
    stroke: "#7552CC",
    strokeWidth: 1.12389
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 756.135,
    cy: 613.133,
    r: 749.581,
    stroke: "#7552CC",
    strokeWidth: 1.12389
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.876,
    cy: 612.876,
    r: 602.095,
    stroke: "#7552CC",
    strokeWidth: 1.12389
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 755.666,
    cy: 612.664,
    r: 450.159,
    stroke: "#7552CC",
    strokeWidth: 1.12389
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 756.281,
    cy: 613.283,
    r: 295.68,
    stroke: "#7552CC",
    strokeWidth: 1.12389
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYsfHomePattern);
export default __webpack_public_path__ + "static/media/YSFHomePattern.6601e73631a5081c7b00d321f24c82ae.svg";
export { ForwardRef as ReactComponent };